let baseURL = "/";

if (process.env.NODE_ENV === "development") {
  baseURL = "https://api.talantahrm.com/";
} else {
  baseURL = "https://api.talantahrm.com/";
}

const config = {
  baseURL,
};

//console.log(baseURL);

export default config;
